

baseState =
    abstract: true
    url: "/{id:int}"
    templateUrl: 'empty'
    resolve: changeLogItem: ($stateParams, ChangeLogService) ->
        'ngInject'
        return ChangeLogService.get($stateParams.id)


viewState =
    url: ''
    template: '<change-log-item item="ctrl.changeLogItem"></change-log-item>'
    controllerAs: 'ctrl'
    controller: (changeLogItem) ->
        'ngInject'
        @changeLogItem = changeLogItem
        return



stateConfig = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'changeLog.item', baseState
    $stateProvider.state 'changeLog.item.view', viewState

    return


module.config stateConfig
